$(document).ready(function () {
  if ($('.food-waste.prr-site-content').length) {
    const prevArrow = `
    <button type="button" class="slick-prev">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="29" viewBox="0 0 17 29" fill="none">
      <path d="M2.5 14.0745L1.43934 13.0138L0.37868 14.0745L1.43934 15.1351L2.5 14.0745ZM13.9393 27.6351C14.5251 28.2209 15.4749 28.2209 16.0607 27.6351C16.6464 27.0493 16.6464 26.0996 16.0607 25.5138L13.9393 27.6351ZM13.9393 0.513803L1.43934 13.0138L3.56066 15.1351L16.0607 2.63512L13.9393 0.513803ZM1.43934 15.1351L13.9393 27.6351L16.0607 25.5138L3.56066 13.0138L1.43934 15.1351Z" fill="#135756"/>
      </svg>
    </button>
  `;
    const nextArrow = `
      <button type="button" class="slick-next">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="29" viewBox="0 0 17 29" fill="none">
        <path d="M14.5 14.0745L15.5607 15.1351L16.6213 14.0745L15.5607 13.0138L14.5 14.0745ZM3.06066 0.513802C2.47488 -0.0719844 1.52513 -0.0719845 0.939342 0.513802C0.353556 1.09959 0.353556 2.04934 0.939342 2.63512L3.06066 0.513802ZM3.06066 27.6351L15.5607 15.1351L13.4393 13.0138L0.93934 25.5138L3.06066 27.6351ZM15.5607 13.0138L3.06066 0.513802L0.939342 2.63512L13.4393 15.1351L15.5607 13.0138Z" fill="#135756"/>
        </svg>
      </button>
    `;

    // 4 columns slider, default with 3 columns below this one
    $('.cards-slider.four-columns').not('.slick-initialized').slick({
      slidesToShow: 4,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
              }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
        }, {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '30px',
              arrows: false,
            }
          }
      ]
    });

    $('.cards-slider').not('.slick-initialized').slick({
      slidesToShow: 3,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
              }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
        }, {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '30px',
              arrows: false,
            }
          }
      ]
    });
  }
});